import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.position()
  }

  position() {
    const top = document.documentElement.clientHeight - this.element.offsetHeight + 1;
    document.body.style.paddingBottom = `calc(${this.element.offsetHeight}px - 1.5rem)`

    this.element.style.width = "100%"
    this.element.style.position = "fixed"
    this.element.style.top = `${top}px`
  }
}
